import { BrandMark } from "@/components/shared/brand-mark";
export function Footer() {
  return (
    <footer className="bg-white border-top-2 mt-auto scp-footer">
      <div className="container page__container page-section d-flex flex-column">
        <p className="text-70 brand mb-24pt">
          <span className="avatar avatar-sm brand-icon mr-8pt">
            <span className="avatar-title rounded bg-primary">
              <BrandMark />
            </span>
          </span>
          SCP
        </p>
        <p className="measure-lead-max text-50 small mr-8pt">
          Sistema corporativo de capacitacion, cumplimiento y auditoria.
          Gestione programas obligatorios, evaluaciones, evidencia documental y
          certificados desde un unico expediente institucional.
        </p>
        <p className="text-50 small mt-n1 mb-0">
          &copy; {new Date().getFullYear()} SCP. Todos los derechos reservados.
        </p>
      </div>
    </footer>
  );
}
